const styles = {
  leftColumn: { display: 'flex', flexBasis: '60%' },
  leftColumnInner: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingRight: '5px',
  },
  rightColumn: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingLeft: '5px',
  },
  rightColumnInner: {
    flex: 1,
  },
  columnContent: {
    background: 'white',
    padding: '15px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  fieldsContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '10px 10px 0px 10px',
    flexBasis: '90%',
  },
  tiles: {
    projectDescription: {
      display: 'flex',
      flexBasis: '50%',
      paddingBottom: '5px',
    },
    projectPrivacy: {
      display: 'flex',
      flexBasis: '15%',
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    projectIcon: {
      display: 'flex',
      flexBasis: '20%',
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    projectTypography: {
      flexBasis: '25%',
      paddingTop: '5px',
      display: 'flex',
    },
  },
  formStyle: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#F2F2F2',
    alignItems: 'center',
    padding: '15px',
  },
  descriptionWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  switcherBoxWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  switcherWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  switcherUrlWrapper: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
  },
  favicon: {
    width: '100px',
    height: '100px',
    color: '#000',
    border: '1px solid #000',
    fontSize: '12px',
  },
  testConnectionButton: {
    marginRight: '0px',
    float: 'right',
    width: 'auto',
    border: '1px solid #ccc',
    background: '#eee',
    display: 'inline-block',
    minWidth: '0px',
  },
  submitBarWrapper: {
    display: 'flex',
    flex: '0 0 10%',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#F2F2F2',
    padding: '10px',
  },
  submitBarInner: {
    display: 'flex',
    flexDirection: 'row',
    flexBasis: '30%',
    background: 'white',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cancelButtonWrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },
  cancelButton: {
    marginRight: '0px',
    background: 'rgb(72,97,102)',
    color: '#ccc',
  },
  submitButtonWrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
  },
  submitButton: {
    background: 'rgb(45,228,136)',
    marginLeft: '0px',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectForm/ProjectForm.styles.js